import * as React from 'react';
import Svg, {SvgProps, Path, Rect} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={19}
    height={16}
    viewBox={'0 0 19 16'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      stroke={props.fill || '#fff'}
      strokeLinecap="round"
      strokeWidth={2}
      d="M1 11C1 5.477 4.806 1 9.5 1S18 5.477 18 11"
    />
    <Rect width={6} height={7} y={9} fill="#fff" rx={3} />
    <Rect width={6} height={7} x={13} y={9} fill="#fff" rx={3} />
  </Svg>
);
export default SvgComponent;
